import { usePortalNotifications } from '@/context';
import React, { useEffect, useMemo } from 'react';

const withNotificationDataWrapper =
  (WrappedComponent: any) =>
  ({ onHasUnreadNotificationsChange, ...props }: any) => {
    const { notifications, unreadNotificationCount } = usePortalNotifications();

    const notificationProps = useMemo(
      () => ({ notifications: notifications ?? [], unreadCount: unreadNotificationCount }),
      [notifications, unreadNotificationCount],
    );

    useEffect(() => {
      onHasUnreadNotificationsChange(!!unreadNotificationCount);
    }, [unreadNotificationCount, onHasUnreadNotificationsChange]);

    return (
      <div>
        <WrappedComponent {...notificationProps} {...props} />
      </div>
    );
  };

export default withNotificationDataWrapper;
